import StarRounded from '@mui/icons-material/StarRounded';

import type { Columns } from './types';

export const COLUMNS: Columns = {
  overdueActionItemCount: { width: '4rem' },
  name: { headline: true, sort: true },
  projectName: { headline: true, sort: true },
  projectCategoryName: { headline: true, sort: true },
  questionnaire: { headline: true, sort: true },
  additionalInformation: { headline: true, sort: true },
  id: {},
  isFavorite: { sort: true, icon: StarRounded, width: '4rem' },
};
export const COLUMNS_LIST = Object.entries(COLUMNS);
export const COLUMNS_LENGTH = COLUMNS_LIST.length;
